import { getSectionsWithRowsFromInputValues, getSummaryValues, getSummaryValuesPriceEnabled, } from '@getaccept/editor-lib-new/src/helpers/pricing-table/editor-node-pricing-table.helper';
import { PricingTableHelper, EBlockWidth, Context } from '@getaccept/editor-lib-new';
import { defineComponent, computed } from 'vue';
import EditorNodeWrapper from '../EditorNodeWrapper.vue';
import PricingTableSection from './PricingTableSection.vue';
import PricingTablePriceSummary from './PricingTablePriceSummary.vue';
export default defineComponent({
    name: 'EditorNodePricingTable',
    components: {
        PricingTablePriceSummary,
        PricingTableSection,
        EditorNodeWrapper,
    },
    props: {
        node: { type: Object, default: () => ({}) },
        sections: { type: Array, default: () => [] },
        mergeValues: { type: Object, required: true },
        blockWidthClass: {
            type: String,
            default: null,
        },
        recipientInput: { type: Array, default: () => [] },
        recipient: {
            type: Object,
            default: () => ({}),
        },
        context: { type: String, default: () => Context.Document },
        allowedToEditAfterPartiallySigned: { type: Boolean },
    },
    emits: ['update-input-value', 'observe-node-visibility'],
    setup(props) {
        const fieldsWithInput = computed(() => PricingTableHelper.fieldsWithRecipientInput(props.node.fields, props.recipientInput));
        const isBlockWidthSmall = computed(() => props.blockWidthClass === EBlockWidth.XXSmall ||
            props.blockWidthClass === EBlockWidth.XSmall);
        return {
            getSectionsWithRowsFromInputValues,
            getSummaryValues,
            getSummaryValuesPriceEnabled,
            fieldsWithInput,
            isBlockWidthSmall,
        };
    },
});
